export function CGV() {
  return (
    <>
      <div className="flex flex-col space-y-2">
        <div className="flex flex-col gap-y-2">
          <p>
            &#9;
            <br />
          </p>
          <p>
            <b>
              CONDITIONS G&#201;N&#201;RALES D&#8217;UTILISATION ET DE VENTE <br />
              1. Pr&#233;sentation de Viastud <br />
            </b>
          </p>
          <p>
            Viastud est une plateforme de soutien scolaire en ligne proposant des cours collectifs
            en <br />
            direct dispens&#233;s par des professeurs qualifi&#233;s, via un syst&#232;me de
            r&#233;servation de cr&#233;neaux <br />
            horaires.
            <br />
            Les pr&#233;sentes Conditions G&#233;n&#233;rales d&#8217;Utilisation et de Vente
            (ci-apr&#232;s les &#171; CGU/CGV <br />
            &#187;) ont pour objet de d&#233;finir les modalit&#233;s d&#8217;acc&#232;s,
            d&#8217;utilisation et de vente des services <br />
            propos&#233;s par Viastud. <br />
          </p>
          <p>
            <b>
              2. Acceptation des CGU/CGV <br />
            </b>
          </p>
          <p>
            L&#8217;utilisation de la plateforme Viastud, ainsi que toute souscription &#224; une
            offre, implique <br />
            l&#8217;acceptation pleine et enti&#232;re des pr&#233;sentes CGU/CGV, sans
            r&#233;serve. <br />
          </p>
          <p>
            <b>
              3. Offres propos&#233;es <br />
              3.1 Cours &#224; l&#8217;unit&#233; <br />
            </b>
          </p>
          <p>
            Viastud propose des cours collectifs en ligne : <br />
            &#8226; Classe de <b>6 &#233;l&#232;ves maximum</b>
            <br />
            &#8226; En direct avec un <b>professeur r&#233;el</b> <br />
            &#8226; Prix : <b>19,99 &#8364; TTC par cours</b> <br />
          </p>
          <p>
            Chaque cours est ind&#233;pendant et doit &#234;tre r&#233;serv&#233; via la plateforme.{' '}
            <br />
            <b>
              3.2 Offres d&#8217;abonnement
              <br />
            </b>
          </p>
          <p>
            Viastud propose deux formules d&#8217;abonnement : <br />
          </p>
          <p>
            &#8226; <b>Abonnement sans engagement</b> : <br />
            179 &#8364; TTC par mois <br />
          </p>
          <p>
            &#8226; <b>Abonnement avec engagement</b> : <br />
            149 &#8364; TTC par mois, avec engagement jusqu&#8217;au <b>30 juin inclus</b> <br />
            &#8594; &#192; compter du <b>1er juillet</b>, l&#8217;abonnement est{' '}
            <b>reconduit automatiquement</b> selon <br />
            les conditions en vigueur, sauf r&#233;siliation pr&#233;alable. <br />
          </p>
          <p>
            L&#8217;abonnement permet d&#8217;acc&#233;der &#224; un nombre{' '}
            <b>illimit&#233; de cours</b>, sous r&#233;serve des r&#232;gles <br />
            de r&#233;servation d&#233;finies ci-dessous.{' '}
          </p>
        </div>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="flex flex-col gap-y-2">
          <p>
            &#9;
            <br />
            <b>
              4. Modalit&#233;s de r&#233;servation des cours <br />
              4.1 R&#233;servation <br />
            </b>
          </p>
          <p>
            &#8226; Un cours doit &#234;tre r&#233;serv&#233; <b>au minimum 24 heures avant</b> son
            heure de d&#233;but.
            <br />
            &#8226; Il est possible de suivre autant de cours que souhait&#233; sur la dur&#233;e.{' '}
            <br />
            &#8226; Toutefois, <b>
              un seul cours peut &#234;tre r&#233;serv&#233; &#224; la fois
            </b>{' '}
            : il est impossible de bloquer <br />
          </p>
          <p>
            plusieurs cr&#233;neaux simultan&#233;ment. <br />
            <b>
              4.2 Annulation <br />
            </b>
          </p>
          <p>
            &#8226; Toute annulation doit intervenir <b>au moins 12 heures avant</b> le d&#233;but
            du cours. <br />
            &#8226; En cas d&#8217;annulation tardive ou d&#8217;absence non justifi&#233;e : <br />
          </p>
          <p>
            o le cours est consid&#233;r&#233; comme consomm&#233;, <br />o une{' '}
            <b>p&#233;nalit&#233; est appliqu&#233;e</b> : impossibilit&#233; de r&#233;server un
            nouveau cours <br />
          </p>
          <p>
            pendant <b>48 heures</b>. <br />
          </p>
          <p>
            <b>
              5. D&#233;roulement des cours <br />
            </b>
          </p>
          <p>
            Les cours sont dispens&#233;s en ligne, en direct, selon le cr&#233;neau
            r&#233;serv&#233;. <br />
            Viastud se r&#233;serve le droit : <br />
          </p>
          <p>
            &#8226; de maintenir un cours m&#234;me s&#8217;il n&#8217;y a qu&#8217;un seul
            &#233;l&#232;ve inscrit,
            <br />
            &#8226; ou d&#8217;annuler exceptionnellement un cours (notamment en cas
            d&#8217;indisponibilit&#233; du <br />
          </p>
          <p>
            professeur), sans que cela n&#8217;ouvre droit &#224; indemnisation. <br />
          </p>
          <p>
            <b>
              6. Statut des professeurs <br />
            </b>
          </p>
          <p>
            Les professeurs intervenant sur Viastud sont des <b>prestataires ind&#233;pendants</b>.{' '}
            <br />
            Ils ne sont ni salari&#233;s ni repr&#233;sentants de Viastud. <br />
          </p>
          <p>
            <b>
              7. Interdiction de contournement de la plateforme <br />
            </b>
          </p>
          <p>
            Il est strictement interdit : <br />
            &#8226; de prendre contact directement avec un professeur en dehors de la plateforme,{' '}
            <br />
            &#8226; de solliciter ou proposer des cours priv&#233;s hors Viastud, <br />
            &#8226; de d&#233;tourner les outils, ressources ou contacts fournis par Viastud. <br />
          </p>
          <p>
            Tout manquement pourra entra&#238;ner : <br />
            &#8226; la suspension ou la r&#233;siliation imm&#233;diate du compte, <br />
            &#8226; sans remboursement, <br />
            &#8226; et le cas &#233;ch&#233;ant des poursuites.{' '}
          </p>
        </div>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="flex flex-col gap-y-2">
          <p>
            &#9;
            <br />
            <b>
              8. Obligations de l&#8217;utilisateur <br />
            </b>
          </p>
          <p>
            L&#8217;utilisateur s&#8217;engage &#224; : <br />
            &#8226; assister aux cours de mani&#232;re s&#233;rieuse et respectueuse, <br />
            &#8226; disposer d&#8217;un mat&#233;riel et d&#8217;une connexion internet
            fonctionnels,
            <br />
            &#8226; ne pas perturber le d&#233;roulement des cours. <br />
          </p>
          <p>
            Tout comportement inappropri&#233; pourra entra&#238;ner l&#8217;exclusion temporaire ou
            d&#233;finitive de
            <br />
            la plateforme. <br />
          </p>
          <p>
            <b>
              9. Absence de garantie de r&#233;sultat <br />
            </b>
          </p>
          <p>
            Viastud est tenue &#224; une <b>obligation de moyens</b>, et non de r&#233;sultat.{' '}
            <br />
            La progression scolaire d&#233;pend notamment de : <br />
          </p>
          <p>
            &#8226; l&#8217;assiduit&#233; de l&#8217;&#233;l&#232;ve, <br />
            &#8226; sa participation active, <br />
            &#8226; son travail personnel. <br />
          </p>
          <p>
            Aucune garantie de r&#233;ussite ou de progression sp&#233;cifique n&#8217;est promise.{' '}
            <br />
          </p>
          <p>
            <b>
              10. Tarifs et paiement <br />
            </b>
          </p>
          <p>
            Les prix sont exprim&#233;s en euros TTC. <br />
            Le paiement s&#8217;effectue en ligne, par les moyens propos&#233;s sur la plateforme.{' '}
            <br />
            Tout abonnement entam&#233; est d&#251; pour la p&#233;riode correspondante, sauf
            dispositions l&#233;gales <br />
            contraires. <br />
          </p>
          <p>
            <b>
              11. R&#233;siliation <br />
            </b>
          </p>
          <p>
            &#8226; L&#8217;abonnement sans engagement peut &#234;tre r&#233;sili&#233; &#224; tout
            moment. <br />
            &#8226; L&#8217;abonnement avec engagement ne peut &#234;tre r&#233;sili&#233; avant le
            30 juin, sauf cas <br />
          </p>
          <p>
            l&#233;gal ou force majeure. <br />
            &#8226; La r&#233;siliation prend effet &#224; la fin de la p&#233;riode en cours.{' '}
            <br />
          </p>
          <p>
            <b>
              12. Responsabilit&#233; <br />
            </b>
          </p>
          <p>
            Viastud ne saurait &#234;tre tenue responsable : <br />
            &#8226; des interruptions temporaires du service, <br />
            &#8226; des probl&#232;mes techniques ind&#233;pendants de sa volont&#233;, <br />
            &#8226; de l&#8217;utilisation inappropri&#233;e de la plateforme par
            l&#8217;utilisateur.{' '}
          </p>
        </div>
      </div>
      <div className="flex flex-col space-y-2">
        <div className="flex flex-col gap-y-2">
          <p>
            &#9;
            <br />
            <b>
              13. Protection des donn&#233;es personnelles <br />
            </b>
          </p>
          <p>
            Les donn&#233;es personnelles sont trait&#233;es conform&#233;ment &#224; la
            r&#233;glementation en vigueur.
            <br />
            Elles sont utilis&#233;es exclusivement dans le cadre du fonctionnement de Viastud.{' '}
            <br />
          </p>
          <p>
            <b>
              14. Modification des CGU/CGV <br />
            </b>
          </p>
          <p>
            Viastud se r&#233;serve le droit de modifier &#224; tout moment les pr&#233;sentes
            CGU/CGV. <br />
            Les utilisateurs seront inform&#233;s de toute modification substantielle. <br />
          </p>
          <p>
            <b>
              15. Droit applicable et juridiction comp&#233;tente <br />
            </b>
          </p>
          <p>
            Les pr&#233;sentes CGU/CGV sont r&#233;gies par le <b>droit fran&#231;ais</b>. <br />
            Tout litige rel&#232;vera de la comp&#233;tence des tribunaux fran&#231;ais.{' '}
          </p>
        </div>
      </div>
    </>
  )
}
